import React from "react";
import { FaCity, FaRoad, FaPlaneDeparture } from "react-icons/fa";
import "./Services.css";

export default function Services() {
  return (
    <section className="services-section">
      <div className="overlay"></div>
      <div className="services-container">
        <h1 className="services-heading">Our Premium Services</h1>
        <p className="services-subtagline">
          <h1>Comfort, Reliability & Style – Tailored to Your Travel Needs</h1>
        </p>

        <div className="services-grid">
          {/* City Travel */}
          <div className="service-card">
            <FaCity className="service-icon" />
            <h3 className="service-title">City Travel</h3>
            <p className="service-text">
              <h1>Explore Jamshedpur with ease and convenience. Quick, safe, and
              affordable rides within the city limits.</h1>
            </p>
          </div>

          {/* Outstation Highway */}
          <div className="service-card">
            <FaRoad className="service-icon" />
            <h3 className="service-title">Highway Trips</h3>
            <p className="service-text">
              Long-distance journeys made relaxing. Enjoy comfort, style, and
              safe rides to Ranchi, Kolkata & beyond.
            </p>
          </div>

          {/* Airport Pickup */}
          <div className="service-card">
            <FaPlaneDeparture className="service-icon" />
            <h3 className="service-title">Airport Pickup</h3>
            <p className="service-text">
              Timely and reliable airport transfers. Start and end your journey
              stress-free with our professional drivers.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
